// extracted by css-extract-rspack-plugin
export default {"optionRow":"kzsylv","optionText":"cMp5mU","optionLabel":"pP7IFf","optionDescription":"q3g2Kd"};